import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { DEFAULT_DEXT_RADIO_GROUP_OTHER_INPUT_LENGTH, FIELD_TYPES } from '../../../constants';
import { RadioGroupFieldWUT } from '../../../ui/radio-group-field';
export const DextRadioGroupWUT = props => {
  const fieldType = FIELD_TYPES.DEXT_RADIO_GROUP;
  return /*#__PURE__*/React.createElement(RadioGroupFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    otherInputCharacterLimit: DEFAULT_DEXT_RADIO_GROUP_OTHER_INPUT_LENGTH
  }));
};
//# sourceMappingURL=dext-radio-group-wut.js.map